import { DriverStatus, DriverStatusLabels } from '../enums';
import { ActiveDriver } from '../models';

export const translateDriverStatus = (status?: string): string => {
  if (!status) return '';
  const upperStatus = status.toUpperCase() as DriverStatus;
  return DriverStatusLabels[upperStatus] || status;
};

export const getDriverName = (driver: ActiveDriver): string => {
  return driver.firstName && driver.lastName
    ? `${driver.firstName} ${driver.lastName}`
    : driver.driverId;
};

export { animateMarker } from './animateMarker';
export { DriverStatus, DriverStatusLabels };
